import { useId } from 'react'

import { cn } from 'src/shared/utils/cn'

import BoldCheckmarkIcon from '../../../assets/bold-checkmark'

interface CustomCheckboxProps {
  checked: boolean
  onChange: (checked: boolean) => void
  className?: string
  size?: 'sm' | 'md' | 'lg'
  id?: string
}

const sizeClasses = {
  sm: 'min-w-4 min-h-4',
  md: 'min-w-5 min-h-5',
  lg: 'min-w-6 min-h-6',
}

const iconSizes = {
  sm: 'min-w-1.5 min-h-1.5 size-1.5',
  md: 'min-w-2 min-h-2 size-2',
  lg: 'min-w-2.5 min-h-2.5 size-2.5',
}

const CustomCheckbox = ({ checked, onChange, className, size = 'md', id }: CustomCheckboxProps) => {
  const generatedId = useId()
  const checkboxId = id || generatedId

  return (
    <button
      type="button"
      id={checkboxId}
      onClick={() => onChange(!checked)}
      className={cn(
        'flex items-center justify-center rounded-full border-[0.5px] transition-all duration-200 focus:outline-none',
        checked ? 'border-primary bg-primary' : 'border-border bg-white',
        sizeClasses[size],
        className,
      )}
      aria-checked={checked}
      role="checkbox"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onChange(!checked)
        }
      }}
    >
      <BoldCheckmarkIcon
        className={cn(
          'text-white transition-all duration-200',
          iconSizes[size],
          checked ? 'text-white' : 'text-border',
        )}
      />
    </button>
  )
}

export default CustomCheckbox
